import { useMutation } from "@apollo/client/react";
import { MARK_INVOICE_UPLOAD_DOCUMENT_AS_MANUALLY_HANDLED } from "../../mutations/documentHandler/markInvoiceUploadDocumentAsManuallyHandled";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";
export const useMarkInvoiceUploadDocumentAsMAnuallyHandled = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: () => void;
}) => {
  const [markDocumentAsManuallyHandled, { data, loading, error }] = useMutation(
    MARK_INVOICE_UPLOAD_DOCUMENT_AS_MANUALLY_HANDLED,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS, GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    },
  );

  return { markDocumentAsManuallyHandled, data, loading, error };
};
